import Symbol from '.Symbol';

const previous                = Symbol('previous')       ;

              
	                                
		                                                  
		                                                  
	                  
  

export const x =     (rootStack      )    => {
	let stack        = rootStack;
	let result = stack.next();
	if ( !result.done ) {
		result.value[previous] = stack;
		result = ( stack = result.value ).next();
		for ( ; ; ) {
			if ( result.done ) {
				if ( stack===rootStack ) { break; }
				stack = stack[previous] ;
				result = stack.next(result.value);
			}
			else {
				result.value[previous] = stack;
				result = ( stack = result.value ).next();
			}
		}
	}
	return result.value;
};

                             
                          
	   
		                    
			                                                    
			                                                    
	 
	   
		                             
			                                                 
			                                                 
	  
